import { render } from "./postage_editor.vue?vue&type=template&id=b85aa9a2&scoped=true"
import script from "./postage_editor.vue?vue&type=script&lang=js"
export * from "./postage_editor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85aa9a2"]])

export default __exports__